<!-- <div class="sidebar">
    <ul>
        <li (click)="toggleCollapse()">
            <a class="menu-list btn " [class.collapsed]="isCollapsed" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="icon"
                    xmlns="http://www.w3.org/2000/svg">
                    <path id="btn_home"
                        d="M9 18.5H6C5.72386 18.5 5.5 18.2761 5.5 18V9.4924C5.5 9.18193 5.6442 8.88907 5.89029 8.69978L11.3903 4.46901C11.7497 4.19251 12.2503 4.19251 12.6097 4.46901L18.1097 8.69978C18.3558 8.88907 18.5 9.18193 18.5 9.4924V17.5C18.5 18.0523 18.0523 18.5 17.5 18.5H15C14.4477 18.5 14 18.0523 14 17.5V14C14 13.4477 13.5523 13 13 13H11C10.4477 13 10 13.4477 10 14V17.5C10 18.0523 9.55228 18.5 9 18.5Z"
                        stroke="#656C75" />
                </svg>
                <span *ngIf="!isCollapsed">Home</span>
            </a>
        </li>
    </ul>
</div> -->


<nav class="sidebar">
    <ul style="list-style: none; padding: 0;">
        <section class="main_menu">
            <ng-container *ngIf="showGrievanceuser1">
                <li (click)="toggleCollapse()">
                    <a (click)="showtoGrievance()" matTooltip="{{grievance1}}" [matTooltipPosition]="'left'"
                        routerLink="/grievanceDashboard" class="menu-list btn" [class.collapsed]="isCollapsed"
                        [ngClass]="{'active-tab': activeView ==='grievance' || activeView ==='trackDetails'}">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path id="btn_student"
                                d="M21 9.6L12 6L3 9.6L6.6 11.4M21 9.6V16.8M21 9.6L17.4 11.4M6.6 11.4L12 14.1L17.4 11.4M6.6 11.4V16.8L12 19.5L17.4 16.8V11.4"
                                stroke="#656C75" />
                        </svg>
                        <span *ngIf="!isCollapsed">{{grievance1}}</span>
                    </a>
                </li>
            </ng-container>

            <!-- Grievance Report -->
            <li (click)="toggleCollapse()">
                <a (click)="showtoReport()" matTooltip="Student Reports" [matTooltipPosition]="'left'"
                    class="menu-list btn" [class.collapsed]="isCollapsed"
                    [ngClass]="{'active-tab': activeView ==='report'}">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="btn_revenue"
                            d="M3.79785 3.94824C4.12912 3.94837 4.39746 4.21656 4.39746 4.54785V19.1025H20.5479L20.6689 19.1152C20.9419 19.1714 21.1472 19.4126 21.1475 19.7021C21.1474 19.9918 20.9421 20.2339 20.6689 20.29L20.5479 20.3027H3.19824V4.54785C3.19824 4.21648 3.46648 3.94824 3.79785 3.94824ZM8.58301 11.9238C8.91425 11.9238 9.18242 12.1922 9.18262 12.5234V17.3096C9.18244 17.6408 8.91427 17.9092 8.58301 17.9092C8.2519 17.909 7.98357 17.6407 7.9834 17.3096V12.5234C7.9836 12.1923 8.25191 11.924 8.58301 11.9238ZM12.5713 8.7334C12.9025 8.7335 13.1707 9.00185 13.1709 9.33301V17.3096C13.1707 17.6407 12.9025 17.9091 12.5713 17.9092C12.2402 17.909 11.9709 17.6407 11.9707 17.3096V9.33301C11.9709 9.0019 12.2402 8.73357 12.5713 8.7334ZM16.5596 5.54297C16.8907 5.54317 17.159 5.81146 17.1592 6.14258V17.3096C17.159 17.6407 16.8907 17.909 16.5596 17.9092C16.2285 17.909 15.9592 17.6407 15.959 17.3096V6.14258C15.9591 5.81144 16.2284 5.54314 16.5596 5.54297Z"
                            fill="#656C75" />
                    </svg>

                    <span *ngIf="!isCollapsed">Reports</span>
                </a>
            </li>
            <!--End Grievance Report -->
            
            <!-- <ng-container *ngIf="showGrievanceuser2">
                <li (click)="toggleCollapse()">
                    <a (click)="showtoGrievanceuser2()" matTooltip="{{grievance2}}" [matTooltipPosition]="'left'"
                        class="menu-list btn" [class.collapsed]="isCollapsed"
                        [ngClass]="{'active-tab': activeView ==='grievanceuser2'  || activeView ==='trackDetailsuser2'}">
                     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path id="btn_student"
                                d="M21 9.6L12 6L3 9.6L6.6 11.4M21 9.6V16.8M21 9.6L17.4 11.4M6.6 11.4L12 14.1L17.4 11.4M6.6 11.4V16.8L12 19.5L17.4 16.8V11.4"
                                stroke="#656C75" />
                        </svg>

                        <span *ngIf="!isCollapsed">{{grievance2}}</span>
                    </a>
                </li>
            </ng-container> -->

            <ng-container *ngIf="showGrievanceAdmin">
                <li (click)="toggleCollapse()">
                    <a (click)="showtoAdmin()" matTooltip="{{grievanceAdmin}}" [matTooltipPosition]="'left'"
                        class="menu-list btn" [class.collapsed]="isCollapsed"
                        [ngClass]="{'active-tab': activeView ==='grievanceAdmin'|| activeView ==='trackDetailsAdmin'}">
                         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path id="btn_student"
                                d="M21 9.6L12 6L3 9.6L6.6 11.4M21 9.6V16.8M21 9.6L17.4 11.4M6.6 11.4L12 14.1L17.4 11.4M6.6 11.4V16.8L12 19.5L17.4 16.8V11.4"
                                stroke="#656C75" />
                        </svg>

                        <span *ngIf="!isCollapsed">{{grievanceAdmin}}</span>
                    </a>
                </li>
            </ng-container>

            <ng-container *ngIf="showGrievanceSuperAdmin">
                <li (click)="toggleCollapse()">
                    <a (click)="showtoSuperAdmin()" matTooltip="{{grievancesuperadmin}}" [matTooltipPosition]="'left'"
                        class="menu-list btn" [class.collapsed]="isCollapsed"
                        [ngClass]="{'active-tab': activeView ==='grievanceSuperadmin' || activeView ==='trackDetailsSuperadmin' }">
                       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path id="btn_student"
                                d="M21 9.6L12 6L3 9.6L6.6 11.4M21 9.6V16.8M21 9.6L17.4 11.4M6.6 11.4L12 14.1L17.4 11.4M6.6 11.4V16.8L12 19.5L17.4 16.8V11.4"
                                stroke="#656C75" />
                        </svg>
                        <span *ngIf="!isCollapsed">{{grievancesuperadmin}}</span>
                    </a>
                </li>
            </ng-container>
        </section>
    </ul>
</nav>




<!-- ================================ loader ======================-->
<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>